<template>
  <router-link v-if="!blank" :to="link" :class="classObject">
    {{ text }}
  </router-link>
  <a
    v-else
    :href="link"
    :class="classObject"
    target="_blank"
    rel="noopener noreferrer"
  >
    {{ text }}
  </a>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'TextLink',

  props: {
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    blank: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: true
    },
    iconTarget: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const classObject = computed(() => {
      return {
        textLink: true,
        'textLink-small': props.small,
        '-noArrow': !props.hasArrow,
        '-target': props.iconTarget
      }
    })

    return {
      classObject
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.textLink {
  color: var.$color-main-text;

  &:not(.-noArrow)::after {
    content: '';
    display: inline-block;
    width: 8px;
    height: 8px;
    border-right: 2px solid var.$color-main;
    border-bottom: 2px solid var.$color-main;
    transform: rotate(-45deg) translateY(-1px);
    margin-left: 4px;
    transition: border-color 0.1s;
  }
  &.-target::after {
    content: '';
    display: inline-block;
    width: 14px;
    height: 14px;
    border: none;
    background-image: url('~@/assets/images/icon/blank.svg');
    background-size: contain;
    background-repeat: no-repeat;
    transform: none;
    margin-left: 4px;
    transition: none;
    transform: translateY(3px);
  }
}

.textLink-small {
  font-size: 1.2rem;
}
</style>
